/* BTC Warenkorb (Runde 15) — Zusatzschicht ueber Impulses Cart-System.
   Kern-Kaufstrecke (Qty, Rebuild, Checkout) laeuft weiter komplett ueber
   theme.CartForm/theme.cart; diese Datei synct nur die Redesign-Elemente
   aus dem State-JSON, das btc-cart-items.liquid in .cart__items mitliefert,
   und verdrahtet die neuen Elemente (Entfernen-Icon, Cross-Sell, Sheet, Gift).
   Faellt sie aus, bleibt der Warenkorb voll bedienbar (No-JS-Fallbacks).

   Eigene Cart-Mutationen laufen ueber eine Promise-Queue (Shopify drosselt
   parallele Cart-Calls, Fehler-Log #34/#50: 429 einmal nach 500 ms wiederholen)
   und stossen danach cart:updated + cart:build an — den bestehenden
   Impulse-Rebuild, keinen eigenen. */
(function () {
  'use strict';

  var STATE_SEL = '[data-btc-cart-state]';
  var giftAutoRemoved = {};

  /* ---------- Fetch-Queue ---------- */
  var queue = Promise.resolve();

  function cartFetch(url, payload) {
    var doFetch = function () {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
    };
    var run = function () {
      return doFetch().then(function (res) {
        if (res.status === 429) {
          return new Promise(function (resolve) { setTimeout(resolve, 500); }).then(doFetch);
        }
        return res;
      });
    };
    var result = queue.then(run, run);
    queue = result.catch(function () {});
    return result;
  }

  function rebuild(parsedCart) {
    if (parsedCart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedCart } }));
    }
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function changeLine(key, quantity) {
    return cartFetch('/cart/change.js', { id: key, quantity: quantity })
      .then(function (res) { return res.json(); })
      .then(function (cart) { rebuild(cart); return cart; });
  }

  /* ---------- State lesen + UI syncen ---------- */
  function readState(scope) {
    var el = (scope || document).querySelector(STATE_SEL);
    if (!el) { return null; }
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function syncFromState(state) {
    if (!state) { return; }

    /* Artikelzahl (Drawer-Kopf + Seiten-Unterzeile) */
    var label = state.count_display === 1 ? '1 Artikel' : state.count_display + ' Artikel';
    document.querySelectorAll('[data-btc-count]').forEach(function (el) {
      el.textContent = label;
    });

    /* Fortschritt + Versandzeile (alle Instanzen: Drawer + Seite) */
    var done = state.total >= state.threshold;
    var remaining = Math.max(0, state.threshold - state.total);
    var pct = state.threshold > 0 ? Math.min(100, Math.round(state.total / state.threshold * 100)) : 100;

    document.querySelectorAll('[data-btc-progress]').forEach(function (box) {
      var bar = box.querySelector('[data-btc-progress-bar]');
      var text = box.querySelector('[data-btc-progress-text]');
      var iconDone = box.querySelector('[data-btc-progress-done]');
      var iconOpen = box.querySelector('[data-btc-progress-open]');
      if (bar) { bar.style.width = pct + '%'; }
      if (iconDone) { iconDone.hidden = !done; }
      if (iconOpen) { iconOpen.hidden = done; }
      if (text) {
        if (done) {
          text.textContent = 'Geschafft — dein Versand ist kostenlos.';
          text.classList.add('btc-cart-progress__text--done');
        } else {
          text.innerHTML = 'Noch <strong>' + formatMoney(remaining) + '</strong> bis zum Gratis-Versand';
          text.classList.remove('btc-cart-progress__text--done');
        }
      }
    });

    document.querySelectorAll('[data-btc-shipping]').forEach(function (el) {
      if (done) {
        el.textContent = 'Kostenlos';
        el.classList.add('btc-cart-line__val--free');
      } else {
        el.textContent = state.shipping_label;
        el.classList.remove('btc-cart-line__val--free');
      }
    });

    /* Grusskarten-Zeile */
    document.querySelectorAll('[data-btc-gift-row]').forEach(function (row) {
      row.hidden = !state.gift.active;
      var price = row.querySelector('[data-btc-gift-price]');
      if (price && state.gift.active) { price.textContent = formatMoney(state.gift.price); }
    });

    /* Nur noch die Grusskarte im Korb: Karte automatisch entfernen —
       verhindert einen Checkout, der nur aus der Karte besteht. */
    if (state.gift.only_gift && state.gift.key && !giftAutoRemoved[state.gift.key]) {
      giftAutoRemoved[state.gift.key] = true;
      changeLine(state.gift.key, 0);
    }
  }

  /* ---------- Beobachter: nach jedem CartForm-Rebuild syncen ---------- */
  function observeProducts() {
    document.querySelectorAll('[data-products]').forEach(function (el) {
      new MutationObserver(function () {
        syncFromState(readState(el));
      }).observe(el, { childList: true });
    });
  }

  /* ---------- Entfernen (Icon im Drawer / Textlink auf der Seite) ---------- */
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('[data-btc-remove]');
    if (!link) { return; }
    evt.preventDefault();
    var item = link.closest('.btc-cart-item');
    if (item) { item.style.opacity = '0.4'; }
    changeLine(link.dataset.key, 0);
  });

  /* ---------- Cross-Sell: Unikat direkt hinzufuegen (422 = gerade verkauft) ---------- */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-btc-add]');
    if (!btn || btn.disabled) { return; }
    btn.disabled = true;
    cartFetch('/cart/add.js', { id: parseInt(btn.dataset.btcAdd, 10), quantity: 1 })
      .then(function (res) {
        if (res.status === 422) {
          var card = btn.closest('.btc-cart-cross-card');
          if (card && !card.querySelector('.btc-cart-cross-card__err')) {
            var err = document.createElement('div');
            err.className = 'btc-cart-cross-card__err';
            err.textContent = 'Gerade vergriffen';
            (card.querySelector('.btc-cart-cross-card__body') || card).appendChild(err);
          }
          /* Rebuild filtert die Karte serverseitig weg (nicht mehr available) */
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(rebuild);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          rebuild(cart);
          if (!document.documentElement.classList.contains('js-drawer-open')) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        });
      })
      .catch(function () { btn.disabled = false; });
  });

  /* ---------- Box-Konfigurator (Bottom-Sheet) ---------- */
  var sheetState = { box: null, pkg: null, size: null };

  function sheetEl() { return document.querySelector('[data-btc-sheet]'); }

  function boxData(handle) {
    var el = document.querySelector('[data-btc-cart-boxes]');
    if (!el) { return null; }
    try {
      return JSON.parse(el.textContent).find(function (b) { return b.handle === handle; });
    } catch (err) { return null; }
  }

  function sheetVariant() {
    if (!sheetState.box || !sheetState.pkg || !sheetState.size) { return null; }
    return sheetState.box.variants.find(function (v) {
      return v.o1 === sheetState.pkg && v.o2 === sheetState.size;
    });
  }

  function pkgList(box) {
    var seen = [];
    box.variants.forEach(function (v) {
      if (seen.indexOf(v.o1) === -1) { seen.push(v.o1); }
    });
    return seen;
  }

  function sizeList(box) {
    var seen = [];
    box.variants.forEach(function (v) {
      if (v.o2 && seen.indexOf(v.o2) === -1) { seen.push(v.o2); }
    });
    return seen;
  }

  function renderSheet() {
    var sheet = sheetEl();
    var box = sheetState.box;
    if (!sheet || !box) { return; }

    sheet.querySelector('[data-btc-sheet-name]').textContent = box.title;
    var thumb = sheet.querySelector('[data-btc-sheet-thumb]');
    if (box.image) { thumb.style.backgroundImage = 'url(' + box.image + ')'; }

    /* Paket-Karten aus den echten option1-Werten ("Starter (3 Teile)") */
    var pkgs = sheet.querySelector('[data-btc-sheet-pkgs]');
    pkgs.innerHTML = '';
    pkgList(box).forEach(function (o1) {
      var preise = box.variants.filter(function (v) { return v.o1 === o1; }).map(function (v) { return v.price; });
      var minPreis = Math.min.apply(null, preise);
      var teile = (o1.match(/\(([^)]+)\)/) || [])[1] || '';
      var name = o1.split(' (')[0];
      var vMitBild = box.variants.find(function (v) { return v.o1 === o1 && v.image; });
      var beliebt = /bestseller|beliebt/i.test(o1);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btc-cart-sheet-pkg';
      btn.setAttribute('aria-pressed', String(sheetState.pkg === o1));
      btn.innerHTML =
        (beliebt ? '<span class="btc-cart-sheet-pkg__badge">Beliebteste Wahl</span>' : '') +
        '<span class="btc-cart-sheet-pkg__thumb"' + (vMitBild ? ' style="background-image:url(' + vMitBild.image + ')"' : (box.image ? ' style="background-image:url(' + box.image + ')"' : '')) + '></span>' +
        '<span class="btc-cart-sheet-pkg__body">' +
        '<span class="btc-cart-sheet-pkg__name">' + name + '</span>' +
        (teile ? '<span class="btc-cart-sheet-pkg__sub" style="display:block">' + teile + '</span>' : '') +
        '</span>' +
        '<span class="btc-cart-sheet-pkg__price">' + formatMoney(minPreis) + '</span>';
      btn.addEventListener('click', function () {
        sheetState.pkg = o1;
        /* Rerender ERST nach abgeschlossener Event-Propagation: das Ersetzen
           des geklickten Buttons waehrend des Bubblings kappt seine Eltern-
           Kette — theme.Drawers' Outside-Click sieht closest('.drawer') = null
           und schloss den Drawer (Floris Review 03.08.). */
        setTimeout(renderSheet, 0);
      });
      pkgs.appendChild(btn);
    });

    /* Groessen-Chips: ausverkaufte Kombination = durchgestrichen */
    var sizes = sheet.querySelector('[data-btc-sheet-sizes]');
    sizes.innerHTML = '';
    sizeList(box).forEach(function (o2) {
      var v = box.variants.find(function (x) { return x.o1 === sheetState.pkg && x.o2 === o2; });
      var avail = !!(v && v.available);
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'btc-cart-sheet-size';
      chip.textContent = o2;
      chip.disabled = !avail;
      chip.setAttribute('aria-pressed', String(sheetState.size === o2));
      chip.setAttribute('aria-label', 'Größe ' + o2 + (avail ? (sheetState.size === o2 ? ', ausgewählt' : '') : ', ausverkauft'));
      if (avail) {
        chip.addEventListener('click', function () {
          sheetState.size = o2;
          sheet.querySelector('[data-btc-sheet-err]').hidden = true;
          /* Nach der Propagation rendern — siehe Kommentar am Paket-Button */
          setTimeout(renderSheet, 0);
        });
      }
      sizes.appendChild(chip);
    });

    /* Preis der aktuellen Auswahl + Gratis-Versand-Hinweis */
    var v = sheetVariant() || box.variants.find(function (x) { return x.o1 === sheetState.pkg; });
    sheet.querySelector('[data-btc-sheet-price]').textContent = v ? formatMoney(v.price) : '';
    var st = readState(document);
    var unlock = sheet.querySelector('[data-btc-sheet-unlock]');
    if (st && v) {
      unlock.hidden = !(st.total < st.threshold && st.total + v.price >= st.threshold);
    } else {
      unlock.hidden = true;
    }
  }

  function openSheet(handle) {
    var box = boxData(handle);
    var sheet = sheetEl();
    if (!box || !sheet) { return; }
    var beliebt = pkgList(box).find(function (o1) { return /bestseller|beliebt/i.test(o1); });
    sheetState = { box: box, pkg: beliebt || pkgList(box)[0], size: null };
    sheet.querySelector('[data-btc-sheet-err]').hidden = true;
    renderSheet();
    sheet.hidden = false;
  }

  function closeSheet() {
    var sheet = sheetEl();
    if (sheet) { sheet.hidden = true; }
    sheetState = { box: null, pkg: null, size: null };
  }

  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('[data-btc-box-open]');
    if (opener) {
      openSheet(opener.dataset.btcBoxOpen);
      return;
    }
    if (evt.target.closest('[data-btc-sheet-close]')) {
      closeSheet();
      return;
    }
    var confirm = evt.target.closest('[data-btc-sheet-confirm]');
    if (confirm && !confirm.disabled) {
      var sheet = sheetEl();
      var v = sheetVariant();
      if (!v) {
        sheet.querySelector('[data-btc-sheet-err]').hidden = false;
        return;
      }
      confirm.disabled = true;
      cartFetch('/cart/add.js', { id: v.id, quantity: 1 })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          confirm.disabled = false;
          closeSheet();
          rebuild(cart);
          if (!document.documentElement.classList.contains('js-drawer-open')) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        })
        .catch(function () { confirm.disabled = false; });
    }
  });

  /* Escape schliesst nur das Sheet, nicht den Drawer darunter.
     Gemessen (03.08.): der Drawer schliesst bereits auf KEYDOWN (ueber die
     predictive-search-Kette), theme.Drawers zusaetzlich auf keyup — deshalb
     werden BEIDE Typen an der ersten Station (window, Capture) gestoppt,
     solange das Sheet offen ist; erst das keyup schliesst das Sheet. */
  ['keydown', 'keyup'].forEach(function (typ) {
    window.addEventListener(typ, function (evt) {
      if (evt.keyCode !== 27 && evt.key !== 'Escape') { return; }
      var sheet = sheetEl();
      if (sheet && !sheet.hidden) {
        evt.stopImmediatePropagation();
        if (typ === 'keyup') { closeSheet(); }
      }
    }, true);
  });

  /* ---------- Geschenk-Option: Karte als echtes Line-Item ---------- */
  document.addEventListener('click', function (evt) {
    var toggle = evt.target.closest('[data-btc-gift-toggle]');
    if (!toggle || toggle.disabled) { return; }
    toggle.disabled = true;
    var aktiv = toggle.getAttribute('aria-pressed') === 'true';
    var state = readState(document);
    if (aktiv && state && state.gift.key) {
      changeLine(state.gift.key, 0);
    } else {
      var wrap = toggle.closest('[data-btc-gift]');
      var variantId = wrap ? parseInt(wrap.dataset.btcGiftVariant, 10) : null;
      if (variantId) {
        cartFetch('/cart/add.js', { id: variantId, quantity: 1 })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(rebuild);
      }
    }
  });

  /* Grussnachricht als Line-Property speichern — /cart/change.js mit
     properties erzeugt einen NEUEN Line-Key; der frische Key kommt nach
     dem Rebuild aus dem State-JSON. Debounced, nur bei Aenderung. */
  var giftMsgTimer = null;
  function speichereGiftNachricht(textarea) {
    var state = readState(document);
    if (!state || !state.gift.active || !state.gift.key) { return; }
    var text = textarea.value.trim();
    if (text === (textarea.dataset.btcSaved || '')) { return; }
    textarea.dataset.btcSaved = text;
    cartFetch('/cart/change.js', {
      id: state.gift.key,
      quantity: 1,
      properties: { 'Grußnachricht': text }
    })
      .then(function (res) { return res.json(); })
      .then(rebuild);
  }
  document.addEventListener('input', function (evt) {
    var msg = evt.target.closest('[data-btc-gift-msg]');
    if (!msg) { return; }
    clearTimeout(giftMsgTimer);
    giftMsgTimer = setTimeout(function () { speichereGiftNachricht(msg); }, 1200);
  });
  document.addEventListener('focusout', function (evt) {
    var msg = evt.target.closest('[data-btc-gift-msg]');
    if (!msg) { return; }
    clearTimeout(giftMsgTimer);
    speichereGiftNachricht(msg);
  });

  /* ---------- Submit-Guard: leerer Korb (inkl. Nur-Grusskarte transient) ---------- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (form.id !== 'CartDrawerForm' && form.id !== 'CartPageForm') { return; }
    var state = readState(form);
    if (state && state.count_display === 0) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }
  }, true);

  /* ---------- Init ---------- */
  function init() {
    observeProducts();
    /* Erst-Sync auf der Cart-Seite (serverseitig gerendertes State-JSON) */
    syncFromState(readState(document));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
